import {GridDataResult} from "@progress/kendo-angular-grid";
import {Injectable} from "@angular/core";
import {BehaviorSubject, catchError, map, Observable, tap, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SharedDataService} from "./shared-data.service";
import {environment} from "../../environments/environment";
import {GiiApskaitaFilterApi} from '../api/gii-apskaita-filter.api';

@Injectable({
  providedIn: 'root'
})
export class GiiAtaskaitaService extends BehaviorSubject<GridDataResult> {

  public loading!: boolean;
  private giiAtaskaitaUrl = environment.apiBaseUrl + '/internalApi/fetchFilteredGiiAtask';
  private giiAsmenysUrl = environment.apiBaseUrl + '/internalApi/asmenys';

  constructor(private http: HttpClient,
              private sharedDataService: SharedDataService
  ) {
    super({
      data: [],
      total: 0
    });
  }

  public queryFilteredGiiAtask(filter: GiiApskaitaFilterApi): void {
    this.fetchFilteredGiiAtask(filter).subscribe((x) => super.next(x));
  }

  fetchFilteredGiiAtask(filter: GiiApskaitaFilterApi): Observable<GridDataResult> {
    this.loading = true;
    return this.http.post(this.giiAtaskaitaUrl, filter, { withCredentials: true }).pipe(
      map(
        (response: any) =>
          <GridDataResult>{
            data: response.gridData,
            total: response.count,
          }
      ),
      catchError((error: any) => {
        this.sharedDataService.setKlaidos(error.error);
        return throwError(error);
      }),
      tap(() => (this.loading = false))
    );
  }

  fetchAsmenys(filter: string): Observable<any> {
    return this.http.get(this.giiAsmenysUrl, {
      params: { filter },
      withCredentials: true
    });
  }
}
